import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useMenuPrefs } from "../context/MenuPrefsContext";
import { defaultPathForRole } from "../config/navConfig";

/** After login: open the user's personal start page (правка №5). [Claude] 2026-11-02 */
export default function StartRedirect() {
    const { user, loading } = useAuth();
    const { prefs, loaded } = useMenuPrefs();

    if (loading) return null;
    if (!user) return <Navigate to="/" replace />;
    if (!loaded) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#f5f5f5] text-slate-600">
                Загрузка…
            </div>
        );
    }
    return <Navigate to={defaultPathForRole(user.role, prefs)} replace />;
}
